const CONDITION_LABELS = {
  healthy: "سالم و بدون نقص فنی و بدنی",
  minor_issue: "دارای ایراد جزئی",
  needs_repair: "نیازمند تعمیر",
};

const PARTY_LABELS = {
  seller: "فروشنده",
  buyer: "خریدار",
};

const D = (v) => v || "............";
const numFa = (n) => (n ? Number(n).toLocaleString("fa-IR") : "............");

export function generateContract(data) {
  const seller = data.seller || {};
  const vehicle = data.vehicle || {};
  const deal = data.deal || {};
  const transfer = data.transfer || {};
  const delivery = data.delivery || {};
  const penalty = data.penalty || {};

  const transferParty =
    PARTY_LABELS[data.transferFeeBy] ||
    PARTY_LABELS[transfer.transferFeeBy] ||
    "............";
  const plateParty =
    PARTY_LABELS[data.plateFeeBy] ||
    PARTY_LABELS[transfer.plateFeeBy] ||
    "............";
  const condition =
    CONDITION_LABELS[data.vehicleCondition] ||
    CONDITION_LABELS[delivery.condition] ||
    "............";

  console.log(seller)

  const lines = [
    "بسمه تعالی",
    "",
    "مشخصات فروشنده: خانم/آقای " +
      D(data.firstName || seller.name) +
      " فرزند " +
      D(data.fatherName || seller.fatherName) +
      " به شماره شناسنامه " +
      D(data.idNumber || seller.idNumber) +
      " کد ملی " +
      D(data.nationalCode || seller.nationalCode) +
      " صادره از " +
      D(data.idIssuePlace || seller.idIssuePlace) +
      " تاریخ تولد " +
      D(data.birthDate || seller.birthDate) +
      " آدرس " +
      D(data.address || seller.address) +
      " تلفن ثابت " +
      D(data.phone || seller.phone) +
      " تلفن همراه " +
      D(data.mobile || seller.mobile),
    "",
    "مشخصات خریدار: خانم/آقای " +
      D(data.buyerFirstName || data.buyer?.firstName) +
      " " +
      D(data.buyerLastName || data.buyer?.lastName) +
      " فرزند " +
      D(data.buyerFatherName || data.buyer?.fatherName) +
      " به شماره شناسنامه " +
      D(data.buyerIdNumber || data.buyer?.idNumber) +
      " کد ملی " +
      D(data.buyerNationalCode || data.buyer?.nationalCode) +
      " صادره از " +
      D(data.buyerIdIssuePlace || data.buyer?.idIssuePlace) +
      " تاریخ تولد " +
      D(data.buyerBirthDate || data.buyer?.birthDate) +
      " آدرس " +
      D(data.buyerAddress || data.buyer?.address) +
      " تلفن ثابت " +
      D(data.buyerPhone || data.buyer?.phone) +
      " تلفن همراه " +
      D(data.buyerMobile || data.buyer?.mobile),
    "",
    "مشخصات خودرو: تمام شش دانگ یک دستگاه " +
      D(data.vehicleName || vehicle.name) +
      " مدل " +
      D(data.vehicleModel || vehicle.model) +
      " رنگ " +
      D(data.vehicleColor || vehicle.color) +
      " شماره شاسی " +
      D(data.chassisNumber || vehicle.chassisNumber) +
      " شماره موتور " +
      D(data.engineNumber || vehicle.engineNumber) +
      " پلاک فعلی خودرو " +
      D(data.plateNumber || vehicle.plateNumber) +
      " که خودرو و کلیه مدارک مربوطه با تمامی لوازم منصوبه به رویت خریدار رسیده است.",
    "",
    "ثمن معامله: مبلغ کل " +
      numFa(data.amountRial || deal.amountRial) +
      " ریال معادل " +
      numFa(data.amountToman || deal.amountToman) +
      " تومان می‌باشد که شرایط پرداخت آن به شرح زیر است: " +
      D(data.paymentTerms || deal.paymentTerms),
    "," + D(data.description || deal.description),
    "",
    "۱- هزینه‌های خلافی، کلیه هزینه ثبت سند اعم از شهرداری و مالیات نقل و انتقال به عهده " +
      transferParty +
      " می‌باشد. ۲- هزینه‌های شماره‌گذاری بر عهده " +
      plateParty +
      " می‌باشد. ۳- فروشنده متعهد می‌گردد سند اتومبیل فوق را به نام خریدار و یا هر شخصی که خریدار معرفی نماید انتقال دهد و مسئولیت رسیدگی به خلافی و ثبت سند قطعی تا ۲ ماه به عهده فروشنده می‌باشد. ۴- قولنامه فوق بعد از اتمام نقل و انتقال سند در دفاتر رسمی فاقد اعتبار می‌باشد. ۵- متعاملین قبول و تعهد نمودند در تاریخ " +
      D(data.notaryDate || transfer.notaryDate) +
      " در دفترخانه شماره " +
      D(data.notaryNumber || transfer.notaryNumber) +
      " به آدرس " +
      D(data.notaryAddress || transfer.notaryAddress) +
      " حاضر گردند و بدون هیچ عذری نقل و انتقال را انجام دهند. ۶- این مبایعه در ۳ نسخه تهیه و ثبت گردید و به رویت طرفین رسید و پس از تنظیم سند قطعی از درجه اعتبار ساقط است.",
    "",
    "خودرو به سمع و نظر خریدار رسیده و در تاریخ " +
      D(data.deliveryDate || delivery.date) +
      " ساعت " +
      D(data.deliveryTime || delivery.time) +
      " با وضعیت " +
      condition +
      " تحویل ایشان گردید و از تاریخ و ساعت مذکور مسئولیت هرگونه تخلف اعم از جرایم راهنمایی و رانندگی، مدنی و کیفری برعهده خریدار می‌باشد. کیلومتر فعلی خودرو " +
      numFa(data.vehicleMileage || delivery.mileage) +
      " کیلومتر می‌باشد.",
    "",
    "اینجانب فروشنده اقرار و تأیید می‌نمایم که واریز هرگونه وجه از سوی خریدار به حساب بانکی معرفی‌شده از جانب اینجانب، به منزله دریافت قطعی وجه توسط اینجانب بوده و حق هرگونه ادعا، اعتراض یا مطالبه مجدد نسبت به مبالغ واریزی مذکور را از خود سلب و ساقط می‌نمایم.",
    "",
    "هرگونه تقلب و تدلیس از سوی فروشنده در معامله و همینطور از سوی خریدار به ثمن معامله که مطابق عرف دلیل مغبون شدن طرف دیگر باشد، موجب فسخ مبایعه‌نامه می‌گردد (ماده ۴۳۹ قانون مدنی) و معادل ده درصد ثمن معامله به شخص خسارت‌دیده پرداخت می‌گردد. همچنین کلیه خیارات از جمله خیار غبن به استثنای خیار تدلیس با اقرار طرفین اسقاط گردید.",
  ];

  if (data.penaltyDescription || penalty.description) {
    lines.push("");
    lines.push(data.penaltyDescription || penalty.description);
  }

  lines.push("");
  lines.push(
    "نام و امضا فروشنده:                                                        نام و امضا خریدار:",
  );

  return lines.join("\n");
}
